import { CSSTransition } from 'react-transition-group';
import cns from 'classnames';
import { CommitteeType } from '../common/committee';
import './profile.less';
import styles from './index.module.less';

type CommitteePropsType = {
  committeeData: CommitteeType;
  isCollapse: boolean;
  onClick?: Function;
  className?: string;
};

const CommitteeMD = (props: CommitteePropsType) => {
  const { committeeData, isCollapse, onClick, className } = props;

  const handleClick = () => {
    onClick && onClick(committeeData.id);
  };

  const renderIcon = () => (
    <div className={styles.committee__icon} onClick={handleClick}>
      <img
        src={require('@/assets/images/grey-right-arrow.png').default}
        alt=""
        className={cns(
          styles.committee__icon__img,
          styles[`committee__icon__img--${isCollapse ? 'down' : 'up'}`],
        )}
      />
    </div>
  );

  return (
    <div className={cns(styles.committee, className)}>
      <div className={styles.committee__department}>
        <img src={committeeData.icon} alt="" className={styles.committee__department__icon} />
        <div className={styles.committee__department__info}>
          <div>{committeeData.committee}</div>
          <div>{committeeData.committeeEng}</div>
        </div>
      </div>

      <div className={styles.committee__profile}>{committeeData.profile}</div>
      <CSSTransition in={!isCollapse} timeout={300} classNames="committee-profile" unmountOnExit>
        <div className="committee-profile">
          <div className={styles.committee__leaders}>
            {/* 主任委员 */}
            <div className={styles.committee__leader}>
              <div className={styles.committee__leader__title}>主任委员</div>
              <div className={styles.committee__member}>
                <div className={styles.committee__member__name}>{committeeData.name}</div>
                <div className={styles.committee__member__title}>
                  {Array.isArray(committeeData.appellation)
                    ? committeeData.appellation.join('，')
                    : committeeData.appellation}
                </div>
              </div>
            </div>

            {/* 副主任委员 */}
            {committeeData.viceChairpersons && committeeData.viceChairpersons.length > 0 && (
              <div className={styles.committee__leader}>
                <div className={styles.committee__leader__title}>副主任委员</div>
                <div className={styles.committee__vice_chairmen}>
                  {committeeData.viceChairpersons.map((viceChair, idx) => (
                    <div key={idx} className={styles.committee__member}>
                      <div className={styles.committee__member__name}>{viceChair.name}</div>
                      <div className={styles.committee__member__title}>
                        {Array.isArray(viceChair.appellation)
                          ? viceChair.appellation.join('，')
                          : viceChair.appellation}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* 秘书长 */}
            {committeeData.secretary && (
              <div className={styles.committee__leader}>
                <div className={styles.committee__leader__title}>秘书长</div>
                <div className={styles.committee__member}>
                  <div className={styles.committee__member__name}>
                    {committeeData.secretary.name}
                  </div>
                  <div className={styles.committee__member__title}>
                    {Array.isArray(committeeData.secretary.appellation)
                      ? committeeData.secretary.appellation.join('，')
                      : committeeData.secretary.appellation}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </CSSTransition>
      {renderIcon()}
    </div>
  );
};

CommitteeMD.defaultProps = {
  committeeData: {},
  isCollapse: false,
  onClick: undefined,
};

export default CommitteeMD;
